import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder } from '@angular/forms';
import { Subscription } from 'rxjs';
import { distinctUntilChanged, filter, map, switchMap } from 'rxjs/operators';
import { Widget } from 'src/app/classes';
import { IWidgetProviderService, WIDGET_PROVIDER_SERVICE } from 'src/app/interfaces';
import { User } from 'src/app/lib/user/classes';
import { UserService } from 'src/app/lib/user/services/user.service';
import { SHARE_WITH_CUSTOMERS } from '../user-filter-dialog/classes';

@Component({
  selector: 'app-share-user-filter-form',
  templateUrl: './share-user-filter-form.component.html',
  styleUrls: ['./share-user-filter-form.component.css']
})
export class ShareUserFilterFormComponent implements OnDestroy, OnInit {

  users: User[] = [];
  userMap: { [key: string]: boolean } = {};

  private _subscriptions: Subscription[] = [];

  constructor(
    @Inject(SHARE_WITH_CUSTOMERS) public formArray: FormArray,
    @Inject(WIDGET_PROVIDER_SERVICE) public widgetProviderService: IWidgetProviderService,
    public userService: UserService,
    private _formBuilder: FormBuilder
  ) { }

  ngOnDestroy(): void {
    for (let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this._subscriptions.push(...[
      this.widgetProviderService.widget$
        .pipe(
          filter((x: Widget) => x && typeof (x.widgettype) === 'number' ? true : false),
          map((x: Widget) => x.widgettype),
          distinctUntilChanged(),
          switchMap((widgetType: number) => this.userService.loadAllUsersUsingWidgettype(widgetType))
        )
        .subscribe((users: User[]) => {
          this.users = users;
          for(let user of users){
            if((this.formArray.value as User[]).findIndex(x => x.id === user.id) > -1) this.userMap[user.id] = true;
          }
        })
    ]);
  }

  userClicked = (user: User) => {
    let index = (this.formArray.value as User[]).findIndex(x => x.id === user.id);
    if (index > -1) {
      this.formArray.removeAt(index);
      this.userMap[user.id] = false;
    }
    else {
      this.formArray.push(this._formBuilder.group({ 'id': user.id, 'email': user.email, 'userName': user.userName } as User));
      this.userMap[user.id] = true;
    }
  }

}
